import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { FaChevronRight } from 'react-icons/fa';
import "../styles/dashbaords.scss";
import ClubWizard from "../components/clubWizard/ClubWizard";
import LogOutButtonWithConfirmModal from "../components/LogOutButtonWithConfirmModal";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useParams } from "react-router-dom";

const steps = [
    { key: 'start', label: 'Intro' },
    { key: '1',     label: 'Details' },
    { key: '2',     label: 'Skills' },
    { key: '3',     label: 'Episodes' },
    { key: '4',     label: 'Insights' },
    { key: '5',     label: 'Discussions' },
    { key: '6',     label: 'Schedule' },
];

const Wizard = () => {
    const { step } = useParams();
    const currentIndex = steps.findIndex(s => s.key === (step ?? 'start'));

    return (
        <>
            <Container>
                <Row>
                    <Col xs={11}>
                        <Breadcrumb className="mt-3 mb-0" style={{ '--bs-breadcrumb-divider': 'none' }}>
                            {steps.map((s, i) => (
                                <Breadcrumb.Item
                                    key={s.key}
                                    active={i !== currentIndex}
                                    className={i < currentIndex ? '' : 'text-muted'}
                                >
                                    {i > 0 && <FaChevronRight className="mx-2 text-muted" size={10} />}
                                    <span className={i === currentIndex ? 'fw-semibold' : ''}>
                                        {i > 0 ? `${i}. ` : ''}{s.label}
                                    </span>
                                </Breadcrumb.Item>
                            ))}
                        </Breadcrumb>
                        {/*<small className="text-muted">Step {Math.max(currentIndex, 1)} of {steps.length - 1}</small>*/}
                    </Col>
                    <Col xs={1} className={'text-end mt-3'}>
                        <LogOutButtonWithConfirmModal tooltip_position={'left'}  />
                    </Col>
                </Row>
            </Container>
            <Container className={'page'}>
                <div className={"pt-3 pb-5"}>
                    <Card className={"w-100"}>
                        <ClubWizard />
                    </Card>
                </div>
            </Container>
        </>
    );
};

export default Wizard;
